const tableHeaders = [
  {
    label: '2023 JAN',
    key: 'text1',
    defaultSort: true,
  },
  {
    label: '2023 FEB',
    key: 'text2',
    defaultSort: true,
  },
  {
    label: '2023 MAR',
    key: 'layout',
    defaultSort: true,
  },
  {
    label: '2023 APR',
    key: 'period',
    defaultSort: true,
  },
  {
    label: '2023 MAY',
    key: 'currentOverAllStatus',
    defaultSort: true,
  },
  {
    label: '2023 JUN',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 JUL',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 AUG',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 SEP',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 OCT',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 NOV',
    key: 'action',
    defaultSort: true,
  },
  {
    label: '2023 DEC',
    key: 'action',
    defaultSort: true,
  },
];

export default () => tableHeaders;
